module.exports = __webpack_public_path__ + "img/comment1.5739d35a.png";